import { Link } from 'gatsby';
import React from 'react';
import './style.scss';

function PostNavigator({ prevPost, nextPost }) {
  return (
    <div className="post-navigator">
      <div className="post-navigator-card-wrapper">
        {nextPost && (
          <Link className="post-card prev" key={nextPost.id} to={nextPost.slug}>
            <div className="direction">Previous</div>
            <div className="title">{nextPost.title}</div>
          </Link>
        )}
      </div>
      <div className="post-navigator-card-wrapper">
        {prevPost && (
          <Link className="post-card next" key={prevPost.id} to={prevPost.slug}>
            <div className="direction">Next</div>
            <div className="title">{prevPost.title}</div>
          </Link>
        )}
      </div>
    </div>
  );
}

export default PostNavigator;
